'use client';

import * as React from 'react';
import { useRouter, useSelectedLayoutSegment } from 'next/navigation';
import { WidgetId } from '@/edge/constants';
import { useEdgeConfigWidget } from '@/shared/modules/edge-config';
import { useCurrentLocale } from '@/shared/modules/localization';
import { getRelativePathnameTo } from '@/shared/modules/navigation';
import { buildQaTrackingEntityProps } from '@/shared/modules/qa-tracking-entity';
import { useGetUserIdFromParams } from '../../hooks/use-get-user-id-from-params';
import { ProfileTabs } from '../../types';
import * as Styled from './tabs.styled';
export const Tabs = React.memo(function Tabs() {
  const router = useRouter();
  const locale = useCurrentLocale();
  const selectedTab = useSelectedLayoutSegment();
  const userId = useGetUserIdFromParams();
  const profileModel = useEdgeConfigWidget(WidgetId.Profile);
  const tabs = React.useMemo(() => {
    const pathnameTo = getRelativePathnameTo(locale);
    return [{
      id: ProfileTabs.Overview,
      title: profileModel.strings.overview,
      href: pathnameTo.profileSegment(userId.toString())
    }, {
      id: ProfileTabs.MyLibrary,
      title: profileModel.strings.myLibrary,
      href: pathnameTo.profileLibrarySegment(userId.toString())
    }, {
      id: ProfileTabs.Friends,
      title: profileModel.strings.friends,
      href: pathnameTo.profileFriendsSegment(userId.toString())
    }];
  }, [locale, userId, profileModel.strings.overview, profileModel.strings.friends, profileModel.strings.myLibrary]);
  const getIsTabActive = (tabId: ProfileTabs) => {
    if (tabId === ProfileTabs.Overview && selectedTab === null) {
      return true;
    }
    return tabId === selectedTab;
  };
  return <Styled.Container>
      <Styled.Content>
        {tabs.map(tab => <Styled.Tab key={tab.id} href={tab.href} $active={getIsTabActive(tab.id)} prefetch={false} onMouseEnter={() => router.prefetch(tab.href)} {...buildQaTrackingEntityProps('newProfile.stickyTabs', {
        payload: JSON.stringify({
          tabName: tab.id
        })
      })}>
            {tab.title}
          </Styled.Tab>)}
      </Styled.Content>
    </Styled.Container>;
});